export const BASE_EDITOR_PATH = "/projects";
